import { render } from "./editPosition.vue?vue&type=template&id=0af5580d"
import script from "./editPosition.vue?vue&type=script&lang=js"
export * from "./editPosition.vue?vue&type=script&lang=js"

import "./editPosition.vue?vue&type=style&index=0&id=0af5580d&lang=less"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__